import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import MissionSelectMultiple from 'component/menuMission/MissionSelectMultiple'
import Modal from '../Modal'
import Button from '../Button'
import SuccessModal from '../Modal/SuccessModal'

class ApproversEditForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      missionsSelected: [],
      missionsChoosed: false,
      dsLdap: '',
      ldapDisabled: false,
      missionDisabled: false,
      presentSuccess: false,
    }
  }

  beforeSubmit = () => {
    /* istanbul ignore else */
    if (this.state.missionsSelected) {
      this.handleSubmit()
    }
  }

  handleSubmit = () => {
    const {
      onSubmit,
      values: { dsMissions },
    } = this.props
    const mapMissions = dsMissions.map((a) => a.label)
    onSubmit(mapMissions, () => this.presentSuccessModal())
    this.setState({ missionsSelected: [] })
    this.clearFields()
  }

  presentSuccessModal = () => {
    this.setState({
      presentSuccess: true,
    })
  }

  handleChangeMissions = (value) => {
    const field = this.props.fields
    field.dsMissions.input.onChange(value)
    this.setState({ missionsSelected: value.target.value || [] })
  }

  clearFields = () => {
    const { setValueToField } = this.props
    setValueToField('dsMissions', [])
  }

  render() {
    const {
      translate,
      values,
      auth: { user },
      options,
    } = this.props

    const field = this.props.fields

    const { missionsSelected, presentSuccess } = this.state

    return (
      <div className='float-right'>
        {presentSuccess && (
          <SuccessModal
            t={translate}
            handleClose={() => this.setState({ presentSuccess: false })}
            size='md'
            msg={translate('punctual.adj.approvers.mission.added')}
          />
        )}
        <Modal
          center
          title={
            <h3 className='color-primary'>
              <b>{translate('punctual.adj.approvers.new.mission')}</b>
            </h3>
          }
          confirmButtonText={translate('register_button')}
          cancelButtonText={translate('cancel_button')}
          className='modal-btn-margin'
          size='md'
          overflow='visible'
          isConfirmButtonDisabled={!missionsSelected.length}
          onConfirm={() => this.handleSubmit()}
          renderButton={({ onClick }) => (
            <Button
              onClick={onClick}
              className='modal-btn-margin btn btn-primary margin-right'
              text={translate('punctual.adj.approvers.new.mission')}
            />
          )}
        >
          <div>
            <Row>
              <span>
                {translate('punctual.adj.approvers.select.one.or.more')}
              </span>
            </Row>
            <Row className='approver-modal-select'>
              <Col>
                <Field
                  {...field.dsMissions}
                  error={translate(field.dsMissions.error)}
                  label={translate('punctual-adjust-approvers.choose-mission')}
                  input={{ value: missionsSelected }}
                >
                  <MissionSelectMultiple
                    {...field.dsMissions.input}
                    values={values.dsMissions}
                    placeholder={translate(
                      'punctual-adjust-approvers.choose-mission'
                    )}
                    onChange={(value) => {
                      this.handleChangeMissions({ target: { value } })
                    }}
                    user={user}
                    translate={translate}
                    options={options}
                  />
                </Field>
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    )
  }
}

ApproversEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  invertStates: PropTypes.func.isRequired,
  setValueToField: PropTypes.func,
  resetForm: PropTypes.func,
  options: PropTypes.array,
}

const fields = ['dsMissions']

export default Form({ fields })(ApproversEditForm)

export { ApproversEditForm }
